import { render, staticRenderFns } from "./SubtitleCatalogs.vue?vue&type=template&id=329b452e&scoped=true&"
import script from "./SubtitleCatalogs.vue?vue&type=script&lang=ts&"
export * from "./SubtitleCatalogs.vue?vue&type=script&lang=ts&"
import style0 from "./SubtitleCatalogs.vue?vue&type=style&index=0&id=329b452e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329b452e",
  null
  
)

export default component.exports